<div id="aboutMe" class="about-me-frame">
    <div class="a2-frame">
        <a id="a2" href="#contactFrame">
            Send a message
        </a>
    </div>

    <div class="sub-title">
        About me
    </div>
    
    <div class="text-pic-frame">
        <div class="left-frame">
            <div class="text-frame" id="textFrame">
                <div class="text" [innerHTML]="myOfferText"></div>
                <div class="btn-frame">
                    <a id="a1" href="#contactFrame">
                        Let's talk
                    </a>
                    <div id="a1" (click)="toggleTextOverlay($event)">about me</div>
                </div>    
                <div class="text-overlay" *ngIf="showTextOverlay" (click)="closeTextOverlay($event)">
                    <div class="overlay-content" (click)="$event.stopPropagation()">            
                        <button class="close-overlay" (click)="toggleTextOverlay()">
                            <img src="assets/icons/close.png" alt="close">
                        </button>
                        <div class="text" [innerHTML]="aboutMeText"></div>            
                    </div>
                </div>
            </div>                         
        
        </div>
        <div class="right-frame">
            <div class="portrait">
                <img class="img-portrait" src="assets/images/portrait1.jpg" alt="portrait">
            </div>
            <div class="arrow-frame">
                <a id="a3" href="#mySkills">
                    <img class="arrow-left-down" src="assets/icons/arrow-left-pic.png" alt="arrow-left">
                </a>
            </div>
        </div>
    </div>
</div>